/**
 * Handle state of alerts
 */
import {
  ACTION_ADD_PRICE_ALERT,
  ACTION_CONSUME_ALERT,
  ACTION_SET_PRICE_ALERTS,
  ACTION_GET_PRICE_ALERTS,
  ACTION_TRIGGER_PRICE_ALERT,
  ACTION_CANCEL_ALERT,
  ACTION_PUT_PRICE_ALERT,
  ACTION_SET_CREATING_PRICE_ALERTS,
} from '../actions/price_alerts';
import { enums, IPriceAlert } from '@kattana-io/common';

export interface IPriceAlertsState {
  loading: boolean;
  pending: IPriceAlert[];
  activated: IPriceAlert[];
  creating: boolean;
}

const defaultState = {
  loading: false,
  pending: [],
  activated: [],
  creating: false
};

const cancelAlert = (state: IPriceAlertsState, payload: any) => {
  const { uuid } = payload;
  return {
    ...state,
    pending: state.pending.map((alert: IPriceAlert) => {
      if (alert.uuid == uuid) {
        return {
          ...alert,
          status: 'CANCELED',
        };
      }
      return alert;
    }),
  };
};

const updatePrice = (state: IPriceAlertsState, payload: any) => {
  const { uuid } = payload;
  return {
    ...state,
    pending: state.pending.map((alert: IPriceAlert) => {
      if (alert.uuid == uuid) {
        return {
          ...alert,
          price: Number(payload.price),
          price_usd: Number(payload.price_usd),
        };
      }
      return alert;
    }),
  };
};

const priceAlertsReducer = (
  state: IPriceAlertsState = defaultState,
  action: any
) => {
  switch (action.type) {
  case ACTION_ADD_PRICE_ALERT:
    return {
      ...state,
      pending: [action.payload, ...state.pending],
      creating: false,
    };
  case ACTION_TRIGGER_PRICE_ALERT:
    return {
      ...state,
      pending: state.pending.map((item) => {
        if (item.id == action.payload.id) {
          item.status = enums.PriceAlertStatus.FIRED;
        }
        return item;
      }),
      activated: [action.payload, ...state.activated],
    };
  case ACTION_CANCEL_ALERT:
    return cancelAlert(state, action.payload);
  case ACTION_CONSUME_ALERT:
    return {
      ...state,
      pending: state.pending.map((item) => {
        if (item.id == action.payload.id) {
          item.status = enums.PriceAlertStatus.CONSUMED;
        }
        return item;
      }),
      activated: state.activated.filter(
        (item) => item.id != action.payload.id
      ),
    };
  case ACTION_GET_PRICE_ALERTS:
    return {
      ...state,
      loading: true,
      pending: [],
    };
  case ACTION_SET_PRICE_ALERTS:
    return {
      ...state,
      loading: false,
      pending: action.payload,
    };
  case ACTION_SET_CREATING_PRICE_ALERTS:
    return {
      ...state,
      creating: action.payload,
    };
  case ACTION_PUT_PRICE_ALERT:
    return updatePrice(state, action.payload);
  default:
    return state;
  }
};

export default priceAlertsReducer;
